import { render, staticRenderFns } from "./News260702.vue?vue&type=template&id=6699b00f&scoped=true&"
import script from "./News260702.vue?vue&type=script&lang=js&"
export * from "./News260702.vue?vue&type=script&lang=js&"
import style0 from "./News260702.vue?vue&type=style&index=0&id=6699b00f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699b00f",
  null
  
)

export default component.exports